// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AdvancesSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_AdvanceSummaryRow } from './Payroll_AdvanceSummaryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_AdvancesSummaryResponseDados = Payroll_AdvanceSummaryRow[];

export type Payroll_AdvancesSummaryResponse = ApiResponse<Payroll_AdvancesSummaryResponseDados>;

registerResponseContract('Payroll_AdvancesSummaryResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      user_id:         { type: 'string',  required: true },
      total_advances:  { type: 'number',  required: true },
      advance_count:   { type: 'number',  required: true },
      advance_details: {
        type: 'array',
        required: true,
        items: {
          id:             { type: 'number',  required: true },
          recebimento_id: { type: 'number',  required: true },
          amount:         { type: 'number',  required: true },
          date:           { type: 'string',  required: false },
          cliente_nome:   { type: 'string',  required: false },
        },
      },
    },
  },
})
